interface SystemProviderProps {
  children?: JSX.Element | JSX.Element[];
}

export const SystemProvider = (props: SystemProviderProps): JSX.Element => {
  return <div className={"systemProvider"}>{props.children}</div>;
};
